import { LayoutContext } from 'contexts/LayoutContext';
import { styled, SxProp, View } from 'dripsy';
import React, { useContext } from 'react';
import { Image } from 'react-native';

const ExchangeImageBackground = React.memo(() => {
  const ImageView = styled(Image)();
  const layout = useContext(LayoutContext);
  const src = layout.isMobile
    ? require('../../../../assets/images/exchange-bg-mobile.png')
    : require('../../../../assets/images/exchange-sub-account-background.jpg');
  return (
    <View sx={sxStyles.background}>
      <ImageView sx={sxStyles.image} source={src} resizeMode={'stretch'} />
    </View>
  );
});

const sxStyles: Record<string, SxProp> = {
  background: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0
  },
  image: {
    width: '100%',
    height: '100%'
  }
};
export default React.memo(ExchangeImageBackground);
